import cx from 'classnames'
import {Button} from 'components/system/Button'
import {useScreen} from 'hooks/useScreen'
import {AppearanceProvider} from '../../providers/AppearanceProvider'
import {Preview} from './Preview'
import {Steps} from './Steps/Steps'

export const Main = () => {
  const builderManager = AppearanceProvider.useManager()
  const screen = useScreen()

  return (
    <div className="grow w-full overflow-y-scroll bg-[#F4F4F7]">
      <div className="p-4 d:px-8 d:py-6 flex gap-4 w-full flex-row">
        <Steps
          className={cx('w-full d:w-auto d:flex-none d:basis-1/2', {
            '!hidden': screen === 'mobile' && builderManager.mode === 'preview',
          })}
        />

        <div
          className={cx('flex flex-col gap-4 w-full d:w-auto d:flex-none d:basis-1/2 ', {
            '!hidden': screen === 'mobile' && builderManager.mode === 'input',
          })}
        >
          {screen === 'mobile' && <Button.EditChoice onClick={builderManager.setInputMode} />}
          <Preview className="w-full" />
        </div>
      </div>
    </div>
  )
}
